import { ProductionStatus } from "@enums/productionStatus.enum";

export function GetProductionStatusColor(status: ProductionStatus) {
	switch (status) {
		case ProductionStatus.Active:
		case ProductionStatus.Changeover:
			return "#1DFF00";
		case ProductionStatus.ToiletBreak:
		case ProductionStatus.Break:
		case ProductionStatus.QLoop:
		case ProductionStatus.QualityCheck:
		case ProductionStatus.AssistanceRequired:
		case ProductionStatus.ToolTipChange:
		case ProductionStatus.SwarfCleanOut:
			return "#FFA500";
		case ProductionStatus.Idle:
		case ProductionStatus.Inactive:
		case ProductionStatus.InitialCheckFailed:
		case ProductionStatus.Breakdown:
		case ProductionStatus.Maintenance:
			return "red";
		default:
			return "blue";
	}
}